import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'eco-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.scss'],
})

export class HeaderComponent implements OnInit {
    ngOnInit() {
    }
        
    constructor( ) {        
    }
}